import { ModalV2, Text } from 'components';
import React from 'react';
import RewardTypeForm from './RewardTypeForm';

const CreateRewardTypeModal = ({ visible, closeModal, team, existingItems, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess?.();
    closeModal();
  };

  return (
    <ModalV2
      visible={visible}
      closeModal={closeModal}
      width="700px"
      header={<Text h3>Create Reward Type</Text>}
    >
      <RewardTypeForm
        team={team}
        existingItems={existingItems}
        isEditing={false}
        onSuccess={handleSuccess}
        onCancel={closeModal}
      />
    </ModalV2>
  );
};

export default CreateRewardTypeModal;
